import React from "react";

export const anonymousUserContext = {
  isLoggedIn: false,
  name: "anonymous",
  logout() {},
};

export const UserContext = React.createContext(anonymousUserContext);
